module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"count_text":"Only {count} forms are allowed for this plan"},"id":{"count_text":"Hanya {count} form yang diizinkan untuk paket ini"}}')
  delete Component.options._Ctor
}
